import * as React from 'react';
import { useSelector } from 'react-redux';

import { AdfoxBanner } from '../../../components/AdfoxBanner';
import { selectIsAgent } from '../../../selectors';
import { selectIsNewbuildingCpmFormatInCardExperimentGroupA } from '../../../selectors/abExperiments/selectNewbuildingCpmFormatInCard';
import { useApplicationContext } from '../../ApplicationContext';
import { useAdfoxPuids } from '../hooks/useAdfoxPuids';

export const TgbAsideBannerContainer: React.FC = () => {
  const { config } = useApplicationContext();

  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-199718, будет удалён в задаче CD-199865
   */
  const isNewbuildingCpmFormatInCardExperimentGroupA = useSelector(selectIsNewbuildingCpmFormatInCardExperimentGroupA);

  let ADFOX_PARAMETERS: Record<string, string>;

  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-199718, будет удалён в задаче CD-199865
   * Это условие полностью удаляем, дальше удаляем не результативный вариант эксперимента, оставляем результативный
   * ADFOX_PARAMETERS Делаем константой и выносим за компонент
   * Должно остаться только одно условие
   * Не забудь удалить RS из config.json и scheme.json
   */
  if (!config.get('Newbuilding.CpmFormatInCardExperiment.Enabled')) {
    ADFOX_PARAMETERS = {
      p1: 'crtmo',
      p2: 'fkhh',
    };
  } else if (isNewbuildingCpmFormatInCardExperimentGroupA) {
    ADFOX_PARAMETERS = {
      p1: 'dbfkd',
      p2: 'fkhj',
    };
  } else {
    ADFOX_PARAMETERS = {
      p1: 'dbfka',
      p2: 'fkhj',
    };
  }

  const isAgent = useSelector(selectIsAgent);
  const adfoxPuids = useAdfoxPuids();
  const adfoxParameters = React.useMemo(
    () => ({
      ...adfoxPuids,
      ...ADFOX_PARAMETERS,
    }),
    [adfoxPuids],
  );

  return (
    <AdfoxBanner
      disableYan={isAgent}
      params={adfoxParameters}
      minHeight="200px"
      analyticsEventName="TgbAsideBanner"
      width="100%"
    />
  );
};
